import { makeStyles } from '@mui/styles';
import { FunctionField, FunctionFieldProps } from 'react-admin';
import React from 'react';
import { Tooltip } from 'antd';
import { clsx } from 'clsx';
import cls from '@pages/credit/CreditEdit/CreditInvoices/CreditInvoiceStatus/credit-invoice-status.module.css';

export const CxInvoiceBooleanStatus = (props: Partial<FunctionFieldProps>) => {
  const cls = useStyles();

  return (
    <FunctionField {...props} render={(record: any) => {
      if (!props.source || !record) return <></>;

      const status: boolean = record[props.source];

      return (
        <div className={cls.wrap}>
          {status === true ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={clsx(cls.icon, cls.approve)}>
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          ) : null}
          {status === false ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={clsx(cls.icon, cls.deny)}>
              <path d="M18 6 6 18"/>
              <path d="m6 6 12 12"/>
            </svg>
          ) : null}
        </div>
      );
    }}
    />
  );
};

const useStyles = makeStyles({
  wrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  icon: {
    color: '#fff',
    borderRadius: '50%',
    padding: 4,
  },
  approve: {
    background: 'rgb(76, 175, 80)',
  },
  deny: {
    background: 'rgb(255, 87, 34)',
  },
});
